import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/logo.png'


const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Services")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Stress Management")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Clients")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Testimonials")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "386",
  height: "153"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/services" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/stress-management" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/clients" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/testimonials" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    })
  ]))
}